import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Sparkles } from 'lucide-react';
import { fieldDescriptions } from './constants';
import FieldInfo from './FieldInfo';

const AIButton = ({ fieldName, label, formData, setFormData, aiEstimatedFields, openAIDialog }) => {
 return (
 <div className="space-y-2">
 <div className="flex items-center justify-between">
 <Label className="text-sm font-medium">
 {label}
 {fieldDescriptions[fieldName] && <FieldInfo description={fieldDescriptions[fieldName]} />}
 </Label>
 <Button
 type="button"
 variant="ghost"
 size="sm"
 onClick={() => openAIDialog(fieldName, label)}
 className="h-7 text-xs"
 >
 <Sparkles className="w-3 h-3 mr-1" />
 Ask AI
 </Button>
 </div>
 <Input
 type="number"
 step="0.01"
 value={formData[fieldName]}
 onChange={(e) => setFormData({ ...formData, [fieldName]: e.target.value })}
 className={aiEstimatedFields[fieldName] ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' : ''}
 />
 {aiEstimatedFields[fieldName] && (
 <div className="text-xs text-blue-600 dark:text-blue-400 space-y-1">
 <p>
 <Sparkles className="w-3 h-3 inline mr-1" />
 AI: {aiEstimatedFields[fieldName].explanation}
 </p>
 {aiEstimatedFields[fieldName].prompt && (
 <p className="text-xs italic text-muted-foreground">
 Asked: &quot;{aiEstimatedFields[fieldName].prompt}&quot;
 </p>
 )}
 </div>
 )}
 </div>
 );
};

export default AIButton;
